<!-- sizing list -->
<!-- <div *ngIf="commonService.custom_model?.sizing_list?.length" class="row">
  <div class="col-md-12">
    <b class="add-another mb-3">SIZING ASSISTANT</b>
  </div>
  <div *ngFor="let x of commonService.custom_model.sizing_list;" class="col-md-12">
    <div class="card o-hidden mb-4">
      <div class="flex-grow-1 pl-2 d-flex">
        <div class="card-body">
          <b class="w-30 w-sm-100 m-b-0">{{x.name}}</b>
          <ng-container *ngFor="let y of x.value;">
            <p class="w-30 w-sm-100 m-b-0">{{y.name}}</p>
            <p class="w-30 w-sm-100 m-b-0">{{y.unique_name}}</p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="commonService.custom_model?.custom_list?.length || commonService.custom_model?.mm_sets?.length || commonService.custom_model?.notes_list?.length" class="col-md-12 mb-3 border-top"></div>
</div> -->
<div id="customization_pdf">
  <!-- custom list -->
  <div *ngIf="commonService.custom_model?.custom_list?.length" class="row mx-0 mt-2">
    <div class="col-md-12 px-0">        
            <h6 class="dark-font mb-3">CUSTOMIZATION</h6>
    </div>
    <ng-container *ngFor="let x of commonService.custom_model?.custom_list;">
      <div class="col-4 flex mb-3" *ngFor="let y of x.value;">
        <div class="blouse-model-col flex-dir-column">
          <img *ngIf="y.image" [src]="imgBaseUrl+y.image" alt="image">
          <img class="addon-icon opacity6" *ngIf="!y.image" src="assets/images/addon_big.svg" alt="image">
          <div class="blouse-model-col-name mt-2" align="center">
            <h6 class="dark-font mb-1">{{x.name}}</h6>
            <p class="dark-font mb-1">{{y.name}}</p>
            <p *ngIf="commonService.store_details?.type=='quot_based' && y.additional_qty>0" class="dark-font mb-1">
              Qty: {{y.additional_qty}}
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- measurement list -->
  <div *ngIf="commonService.custom_model?.mm_sets?.length" class="row mx-0 d_measure mb-3">
    <div class="col-md-12">
        <h6 class="dark-font mb-3">MEASUREMENTS</h6>
    </div>
    <div *ngFor="let x of commonService.custom_model?.mm_sets;" [ngClass]="(commonService.custom_model?.mm_sets?.length>1)? 'col-6': 'col-12'">
      <div class="card o-hidden mb-4 d-flex flex-row" align="center">
        <div class="blouse-model-col w-100">
          <div align="center">
            <p style="padding: 10px; background-color: dimgray; color:#fff; font-size: 16px;">{{x.name}}</p>
            <img *ngIf="x.image" [src]="imgBaseUrl+x.image" alt="image" class="img-responsive blouse-mrs" style="height:150px;">
            <img *ngIf="!x.image" src="assets/images/addon_big.svg" alt="image" class="mb-3" style="height:150px;">
          </div>
          <div *ngFor="let y of x.list; let j=index;"
            class="blouse-model-col-name align-self-center d-flex flex-column justify-content-between align-items-lg-center">
            <p>{{y.name}}:
              <span class="dark-font">{{y.value}} {{ commonService.custom_model?.mm_unit }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="commonService.custom_model?.notes_list?.length" class="col-md-12 mb-3 border-top"></div> -->
  </div>
  <!-- notes list -->
  <div *ngIf="commonService.custom_model?.notes_list?.length" class="row">
    <div class="col-md-12">
        <h6 class="dark-font mb-3">NOTES</h6>
    </div>
    <div *ngFor="let x of commonService.custom_model?.notes_list;" class="col-md-12">
      <div class="card o-hidden mb-4">
        <div class="flex-grow-1 pl-2 d-flex">
          <div class="card-body">
            <b class="w-30 w-sm-100 m-b-0 light-font">{{x.name}}</b>
            <p class="w-30 w-sm-100 m-b-0 light-font">{{x.value}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>  